import { Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { EnquiriesApiService } from './enquiries-api.service';

@Injectable({
  providedIn: 'root',
})
export class EnquiriesSidebarBadgeService {
  readonly count = signal(0);
  readonly loading = signal(false);

  private refreshPromise: Promise<void> | null = null;
  private refreshQueued = false;

  constructor(private readonly api: EnquiriesApiService) {}

  async refresh(): Promise<void> {
    this.refreshQueued = true;

    if (this.refreshPromise) {
      return this.refreshPromise;
    }

    this.refreshPromise = this.drainRefreshQueue();
    return this.refreshPromise;
  }

  private async drainRefreshQueue(): Promise<void> {
    this.loading.set(true);

    try {
      while (this.refreshQueued) {
        this.refreshQueued = false;

        try {
          const counts = await firstValueFrom(this.api.getCounts());
          const count = Number(counts?.open ?? 0) + Number(counts?.patientSubmitted ?? 0);
          this.count.set(Number.isFinite(count) ? Math.max(0, count) : 0);
        } catch {
          // Keep the previous count if the badge refresh fails.
        }
      }
    } finally {
      this.loading.set(false);
      this.refreshPromise = null;
    }
  }
}
